import React from 'react';
import PropTypes from 'prop-types';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';

const SpiideoVenuesFilters = ({
    filters,
    loading,
    restoreFilterValues,
}) => (
    <div className='content__filters'>
        <SearchFilter
            loading={loading}
            filters={filters.SpiideoVenues}
            restoreFilterValues={restoreFilterValues}
        />
    </div>
);

SpiideoVenuesFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(SpiideoVenuesFilters, {name: 'SpiideoVenues'});
